import { Outlet } from 'react-router-dom'

import { SynopsConnected } from '@/modules/app/pages/synops/SynopsConnected'

const SynopsGuard = () => (
  <SynopsConnected>
    <Outlet />
  </SynopsConnected>
)

export { SynopsGuard }
